/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Shell_Profile_Label_PctInputs */

const en_us2_shell_profile_label_pct = /** @type {(inputs: Shell_Profile_Label_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profile ${i?.pct}% complete`)
};

const pt_br2_shell_profile_label_pct = /** @type {(inputs: Shell_Profile_Label_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perfil ${i?.pct}% completo`)
};

const es_419_shell_profile_label_pct = /** @type {(inputs: Shell_Profile_Label_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perfil ${i?.pct}% completo`)
};

const pt_pt2_shell_profile_label_pct = /** @type {(inputs: Shell_Profile_Label_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perfil ${i?.pct}% completo`)
};

const fr_fr2_shell_profile_label_pct = /** @type {(inputs: Shell_Profile_Label_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profil complété à ${i?.pct} %`)
};

const de_de2_shell_profile_label_pct = /** @type {(inputs: Shell_Profile_Label_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profil zu ${i?.pct}% vollständig`)
};

const it_it2_shell_profile_label_pct = /** @type {(inputs: Shell_Profile_Label_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profilo completo al ${i?.pct}%`)
};

/**
* | output |
* | --- |
* | "Profile {pct}% complete" |
*
* @param {Shell_Profile_Label_PctInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_profile_label_pct = /** @type {((inputs: Shell_Profile_Label_PctInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Profile_Label_PctInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_profile_label_pct(inputs)
	if (locale === "es-419") return es_419_shell_profile_label_pct(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_profile_label_pct(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_profile_label_pct(inputs)
	if (locale === "de-DE") return de_de2_shell_profile_label_pct(inputs)
	if (locale === "it-IT") return it_it2_shell_profile_label_pct(inputs)
	return en_us2_shell_profile_label_pct(inputs)
});
export { shell_profile_label_pct as "shell.profile_label_pct" }